export const MEMBER_REPORTING_SLICE_KEY = 'memberReporting' as const;
